(function () {
	'use strict';

	/**
	 * @ngdoc directive
	 * @name mx.components:mxIframe
	 * @module mx.components
	 * @restrict 'E'
	 * @scope {}
	 * @description Renders IFRAME
	 *
	 * @param {string} src< - Sets the IFrame source
	 */

	MxIFrameCtrl.$inject = ['$scope', '$sce', '$element'];

	function MxIFrameCtrl(scope, $sce, $element) {
		var vm = this;
		vm.frameSource = null;

		vm.$postLink = function () {
			var iframe = $element.find('iframe');
			iframe.on('load', function () {
				iframe.contents().find('body').css('margin', '0');
			});
		};

		scope.$watch('vm.src', function (val) {
			vm.frameSource = $sce.trustAsResourceUrl(val);
		});
	}

	angular.module('mx.components').component('mxIframe', {
		controller: MxIFrameCtrl,
		controllerAs: 'vm',
		bindings: {
			src: '@',
			height: '@',
			width: '@',
		},
		scope: {},
		template:
			'<iframe ' +
			'class="mx-frame mx-loading-bg" ' +
			'onload="this.className = \'mx-frame\'" ' +
			'ng-src="{{vm.frameSource}}"  ' +
			"ng-style=\":: {width: vm.width || '100%', height: vm.height || 'calc(100% - 10px)'}\"> " +
			'</iframe>',
	});
})();
